import React from 'react';
import clsx from 'clsx';

import {SvgIconReact} from 'common/components/svg-icon';
import {TooltipReact} from 'common/components/tooltip';
import {TooltipAttrs} from 'common/components/tooltip/types';

import {Necessary} from '../types';
import styles from './index.module.styl';

type InputLabelProps = {
  children?: React.ReactNode;
  className?: string;
  extraInfo?: string;
  fieldId?: string;
  helpText?: string;
  tooltip?: TooltipAttrs;
  helpIconStyleOverrides?: Record<string, string>;
  label?: string;
  necessary?: string;
};

export function InputLabelReact({
  children,
  className,
  extraInfo,
  fieldId,
  helpText,
  tooltip,
  helpIconStyleOverrides,
  label = ``,
  necessary = Necessary.Default,
}: InputLabelProps) {
  return (
    <div className={clsx(styles.mpInputLabelContainer, className)}>
      <label className={styles.mpInputLabel} htmlFor={fieldId}>
        {children ?? label}
      </label>
      {necessary ? <span className={styles.mpInputNecessary}>{necessary}</span> : null}
      {helpText || tooltip?.text ? (
        <div className={styles.mpInputHelpIcon} style={helpIconStyleOverrides}>
          <SvgIconReact icon='info' />
          <TooltipReact maxWidth='500px' {...tooltip}>
            {helpText}
          </TooltipReact>
        </div>
      ) : null}
      {extraInfo ? <div className={styles.mpInputExtraInfo}>{extraInfo}</div> : null}
    </div>
  );
}
